/**
 * Centralized route paths — single source of truth.
 * Import { ROUTES } from '@/lib/routes' instead of hardcoding strings.
 */
export const ROUTES = {
  home: '/',
  nossosDiferenciais: '/nossos-diferenciais',
  nossaEssencia: '/nossa-essencia',
  comoFunciona: '/como-funciona',
  privacidade: '/privacidade',
  sejaNossoParceiro: '/seja-nosso-parceiro',
  guiaDireitoTitulares: '/guia-direito-titulares',
  trabalheConosco: '/trabalhe-conosco',
  denuncia: '/denuncia',
  termosDeUso: '/termos-de-uso',
} as const;

export type RouteKey = keyof typeof ROUTES;
